import { render, staticRenderFns } from "./productSize.vue?vue&type=template&id=d8771ae6&scoped=true"
import script from "./productSize.vue?vue&type=script&lang=js"
export * from "./productSize.vue?vue&type=script&lang=js"
import style0 from "./productSize.vue?vue&type=style&index=0&id=d8771ae6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d8771ae6",
  null
  
)

export default component.exports